import React, {useLayoutEffect, useRef, useState} from 'react';
import queryString from  'qs';
import { CLASS_GENDERS } from '../../../const/user';

//const defaultAvatar = `${process.env.PUBLIC_URL}/images/default_avatar.png`;


const defaultAvatarGender = (gender = 1) =>{
    let avatar = CLASS_GENDERS[gender] || "gender-man";
    return `${process.env.PUBLIC_URL}/images/avatars/${avatar}.jpg`;
}

const generateImageWorkerUri = (uri, query = {}, gender = 1) => {
    return !!uri ? `${uri}?${queryString.stringify(query)}` : defaultAvatarGender(gender);
}

const Avatar = function ({
                             alt,
                             className = "",
                             height = 50,
                             width = 50,
                             avatar,
                             gender = "guest",
                             online = false,
                             // Quand true → l'anneau de genre TOURNE pendant ~10 s pour signaler une
                             // story. L'avatar garde exactement sa couleur de genre : le signal est
                             // le mouvement, pas la teinte (l'ancien anneau or a été retiré).
                             // À n'activer que sur des avatars ISOLÉS (profil, media viewer), jamais
                             // dans une liste : l'appelant doit connaître le ring du membre, ce qui
                             // coûterait une requête par vignette.
                             isStory = false
                         }) {
    const imgDivRef = useRef(null);
    const [_height, setHeight] = useState(height);
    const [_width, setWidth] = useState(width);

    useLayoutEffect(() => {
        setHeight(height || imgDivRef.current.clientHeight);
        setWidth(width || imgDivRef.current.clientWidth);
    }, [height, width, _height, _width]);

    let classGender = CLASS_GENDERS[gender] || CLASS_GENDERS["guest"];
    let avatarIsGroup = false;
    let avatarUri = avatar;
    let query = {height: _height, width: _width};
    //TODO add array slice
    if (Array.isArray(avatar)) {
        if (avatar.length === 1) avatarUri = avatar[0];
        else {
            avatarIsGroup = true;
            classGender = CLASS_GENDERS["group"];
        }
    }
    //TODO => images en erreur
    const avatarNode = (
        <div className={`avatar ${classGender}${isStory ? ' is-story' : ''}`}>
            {!!online && !avatarIsGroup ? (
                <div className="online" />
            ) : null}
            <div className="avatar-container" ref={imgDivRef}>
                {avatarIsGroup
                    ? avatarUri.map((avatar, index) => <div key={index} className="group-img"
                                                            style={{backgroundImage: `url(${generateImageWorkerUri(avatar, query, gender)})`}}/>)
                    : (
                        <img
                            src={generateImageWorkerUri(avatarUri, query, gender)}
                            alt={alt}
                            loading="lazy"
                            className={className}
                        />
                    )
                }
            </div>
        </div>
    );

    return avatarNode;
}

export default Avatar;
